(() => {
/* Wild Gainz mega nav hover opening.
   Progressive enhancement over the click-to-open details menus: devices
   with a real pointer open a menu on hover and close it when the pointer
   leaves both the trigger and the panel. Touch devices, keyboard use, and
   no-JS behavior are untouched, clicking still works everywhere. */

if (window.wildgainzNavHover) return;
window.wildgainzNavHover = true;

// Hover opening only makes sense with a hovering pointer.
if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

const OPEN_DELAY_MS = 80;
const CLOSE_DELAY_MS = 220;

const bind = () => {
  const menus = Array.from(document.querySelectorAll('header-menu > details'));
  menus.forEach((details) => {
    if (details.dataset.hoverBound) return;
    details.dataset.hoverBound = 'true';

    const summary = details.querySelector('summary');
    let openTimer = null;
    let closeTimer = null;

    const setOpen = (open) => {
      if (open) {
        // Only one menu open at a time, switch instantly between them.
        menus.forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      // The short delay stops menus flashing open while the pointer just
      // passes across the header on its way somewhere else.
      openTimer = setTimeout(() => setOpen(true), OPEN_DELAY_MS);
    });

    details.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      // The grace period forgives diagonal travel toward the panel.
      closeTimer = setTimeout(() => setOpen(false), CLOSE_DELAY_MS);
    });
  });
};

bind();
// The theme editor re-renders the header section; rebind for new nodes.
document.addEventListener('shopify:section:load', bind);
})();
